export const drawProvisionType = (type: string, currency?: string) => {
	if (type === "PERCENT") return "%";
	if (type === "AMOUNT" && currency) return currency;
};
